// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2uKIE","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1Gm3L","obliqueLine":"membershipbadge_obliqueLine__32L9T"};